import { tv } from '@costar-ui/cosmos';

var focusRing = tv({
  base: ['outline-0', 'forced-colors:outline-[Highlight]'],
  variants: {
    isFocusVisible: {
      "false": '',
      "true": 'border-focus'
    }
  }
});

export { focusRing };
//# sourceMappingURL=common.esm.js.map
